import { Icon } from "@iconify/react";

const MyBookingBadge = ({ status }) => {
  const getStatusClassName = () => {
    let baseClassName =
      "px-2 py-0.5 rounded-full text-xs font-medium flex flex-row items-center gap-1 ";

    switch (status) {
      case "pending":
        baseClassName += "bg-[#FEF9C2] text-[#A65F00]";
        break;
      case "confirmed":
        baseClassName += "bg-[#DCFCE7] text-[#008236]";
        break;
    }

    return baseClassName;
  };

  const getStatusIcon = () => {
    switch (status) {
      case "pending":
        return "mdi:clock-outline";
      case "confirmed":
        return "mdi:checkbox-marked-circle-outline";
    }

    return "";
  };

  return (
    <div className={getStatusClassName()}>
      <Icon icon={getStatusIcon()} className="w-3 h-3 flex-shrink-0" />
      {status}
    </div>
  );
};

export default MyBookingBadge;
